import { render, staticRenderFns } from "./profitableList.vue?vue&type=template&id=0b1f30b9&scoped=true"
import script from "./profitableList.vue?vue&type=script&lang=js"
export * from "./profitableList.vue?vue&type=script&lang=js"
import style0 from "./profitableList.vue?vue&type=style&index=0&id=0b1f30b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1f30b9",
  null
  
)

export default component.exports